import { toast as reactHotToast, Toaster as ReactHotToaster } from 'react-hot-toast';

import type { ComponentProps } from 'react';

export const toast = reactHotToast;
export const Toaster = ReactHotToaster;

export type ToasterProps = ComponentProps<typeof Toaster>;
